// extracted by mini-css-extract-plugin
export var freeMeasure = "freeMeasure-module--freeMeasure--MdsWt";
export var inputNumber = "freeMeasure-module--inputNumber--KlNqD";
export var buttonShort = "freeMeasure-module--buttonShort--7FV5n";
export var blurBackground = "freeMeasure-module--blurBackground--sQ1bW";